import { useState } from 'react';
import styled from 'styled-components';
import Accordion from '../Accordion';
import { Headline500Skin } from '../../atoms/Headline/HeadlineSkins';

const Headline = styled.h2`
  ${Headline500Skin};
  margin-bottom: 35px;
`;

/**
 * @param {JobMatrixProps} props
 * @returns {React.ReactElement} The rendered component
 */
const JobMatrix = ({ mainHeadline, items }) => {
  const [activeItems, setActiveItems] = useState([]);

  /**
   * @param {number} index
   * @returns {void}
   */
  const handleOnChange = (index) => {
    if (activeItems.includes(index)) {
      const indexActive = activeItems.indexOf(index);
      setActiveItems((aI) => {
        const newaI = aI.slice();
        newaI.splice(indexActive, 1);
        return newaI;
      });
    } else {
      setActiveItems((aI) => {
        const newaI = aI.slice();
        newaI.push(index);
        return newaI;
      });
    }
  };

  return (
    <>
      <Headline>{mainHeadline}</Headline>
      <Accordion
        items={items}
        onChange={handleOnChange}
        activeItems={activeItems}
      />
    </>
  );
};

export default JobMatrix;
